import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import {testIdProps} from '@github-ui/test-id-props'
import {memo} from 'react'

export const DiffEntryLoadingSkeleton = memo(function DiffEntryLoadingSkeleton({
  ariaLabel,
  testId,
}: {
  ariaLabel: string
  testId: string
}) {
  return (
    <div className="pt-3" role="region" aria-label={ariaLabel} {...testIdProps(testId)}>
      <div className="border borderColor-muted rounded-top-2">
        <div className="gap-2 p-3 border-bottom borderColor-muted bgColor-muted rounded-top-2">
          <LoadingSkeleton height="sm" variant="rounded" width="140px" />
        </div>
        <div className="d-flex flex-column gap-2 p-3">
          <LoadingSkeleton height="sm" variant="rounded" width="random" />
          <LoadingSkeleton height="sm" variant="rounded" width="random" />
          <LoadingSkeleton height="sm" variant="rounded" width="random" />
          <LoadingSkeleton height="sm" variant="rounded" width="random" />
        </div>
      </div>
    </div>
  )
})

try{ DiffEntryLoadingSkeleton.displayName ||= 'DiffEntryLoadingSkeleton' } catch {}